import { useAuthStore } from "@/features/auth/stores/authStore";
import { FEATURES, type FeatureKey } from "../permissions/permissions.config";

export function usePermission(
  featureOrPermissions: FeatureKey | string[],
  mode: "all" | "any" = "all"
) {
  const { hasAllPermissions, hasAnyPermission } = useAuthStore();

  const permissions = Array.isArray(featureOrPermissions)
    ? featureOrPermissions
    : FEATURES[featureOrPermissions];

  return mode === "all"
    ? hasAllPermissions(permissions)
    : hasAnyPermission(permissions);
}